module.exports = __webpack_public_path__ + "img/danzi.30ee0b85.svg";